import { type MouseEvent, type ReactNode } from 'react';
import { renderToStaticMarkup } from 'react-dom/server';

import { linkToOrb } from '../../shared/third-party';
import { isProduction } from '../../shared/utils';
import { type Account } from '../model';

import { OrbInterstitialTestModeRedirect } from './OrbInterstitialTestModeRedirect';

type OrbLinkProps = Readonly<{
  orbSubscriptionId: string;
  account: Account;
  children: ReactNode;
  className?: string;
}>;

export function OrbLink({ orbSubscriptionId, account, children, className }: OrbLinkProps) {
  const handleClick = (e: MouseEvent<HTMLAnchorElement>) => {
    if (isProduction()) {
      return; // Let the normal link behavior work for production
    }

    e.preventDefault();

    // For non-production, show a brief notice about test mode before redirecting
    const orbUrl = `https://app.withorb.com/subscriptions/${orbSubscriptionId}`;

    // Render the TSX component to HTML string
    const redirectPageHtml = `<!DOCTYPE html>${renderToStaticMarkup(
      <OrbInterstitialTestModeRedirect orbSubscriptionId={orbSubscriptionId} account={account} orbUrl={orbUrl} />,
    )}`;

    const win = window.open();
    if (win) {
      win.document.write(redirectPageHtml);
      win.document.close();
    }
  };

  return (
    <a
      href={linkToOrb(orbSubscriptionId)}
      target="_blank"
      rel="noopener noreferrer"
      onClick={handleClick}
      className={className}
    >
      {children}
    </a>
  );
}
